import { render, staticRenderFns } from "./centerRight.vue?vue&type=template&id=5fdeafbe&scoped=true&"
import script from "./centerRight.vue?vue&type=script&lang=js&"
export * from "./centerRight.vue?vue&type=script&lang=js&"
import style0 from "./centerRight.vue?vue&type=style&index=0&id=5fdeafbe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdeafbe",
  null
  
)

export default component.exports